import React from "react";
import "./App.css";
import Create from "pages/Create";
import View from "pages/View";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import PopupProvider from "components/context/PopupProvider";
import { BJ_URL } from "constant/config";

window.addEventListener("message", (event) => {
	console.log("window.addEventListener", event);
	const re = new RegExp("https?:" + BJ_URL, "i");
	if (!event.origin.match(re)) return;

	switch (event.data.action) {
		case "darMode":
			document.documentElement.setAttribute("dark", event.data.value);
			if (event.data.value) {
				document.body.classList.add("thema_dark");
			} else {
				document.body.classList.remove("thema_dark");
			}
			break;
	}
});

function App() {
	return (
		<PopupProvider>
			<BrowserRouter>
				<Switch>
					<Route exact path="/" component={Create} />
					<Route path="/:id/:method(edit)" component={Create} />
					<Route path="/:id" component={View} />
				</Switch>
			</BrowserRouter>
		</PopupProvider>
	);
}

export default App;
